module.exports = __webpack_public_path__ + "static/media/hero.eb5fc44c.png";